import cx from 'classnames';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import theme from './tag.module.css';

const getClass = (status) => {
  switch (status) {
    case 'warning':
      return theme.warning;
    default:
      return theme.neutral;
  }
};

export default class Tag extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    status: PropTypes.string
  };

  render() {
    const { value, status } = this.props;

    return (
      <div className={cx(theme.tagContainer, getClass(status))}>
        <div className={theme.tag}>{value}</div>
      </div>
    );
  }
}
